require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _platform = require("./../variables/platform");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports["default"] = function () {
  var variables = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _platform2["default"];
  var h2Theme = {
    color: variables.textColor,
    fontSize: variables.fontSizeH2,
    lineHeight: variables.lineHeightH2
  };
  return h2Theme;
};